import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { Sample } from 'entities/sample'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { Button, Table } from 'react-bootstrap'
import { GlobalStateContext } from 'contexts/global_state_context'
import { Flex } from 'components/shared/flex'
import lodash from 'lodash'
import { A4 } from 'components/shared/print'
import { BiCheckboxChecked } from 'react-icons/bi'
import { ExtractionSearchForm } from 'entities/extraction'
import { useFetchExtractionsApi } from 'api/extraction'
import { InputField } from 'components/shared/input'
import styled from 'styled-components'
import { formatRequestFormCode } from 'utils/formatRequestFormCode'

type Props = {
    history: H.History
}

const Td = styled.td`
    vertical-align: middle;
`

const PickingSamples = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const query = useQuery<ExtractionSearchForm>()
    const searchForm = useForm<ExtractionSearchForm>({ ...query, perPage: 10000 })
    const form = useForm<ExtractionSearchForm[]>([])
    const api = useFetchExtractionsApi(searchForm)
    const section = 32
    const isHomeTest = process.env.REACT_APP_IS_HOME_TEST

    useEffect(() => {
        api.execute()
    }, [])

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
    }, [api.loading])

    const chunks = (): Sample[][] => {
        return lodash.chunk(
            api.response.results.map((e) => e.sample!),
            section
        )
    }

    function focusNextElement(nextTabIndex: number): void {
        const nextElement = document.querySelector(`[tabindex="${nextTabIndex}"]`) as HTMLElement
        if (nextElement) {
            nextElement.focus()
        }
    }

    return (
        <>
            <Flex className="no-print" style={{ marginLeft: 20 }} alignItems="flex-end">
                <div style={{ padding: 15 }}>
                    <Button
                        style={{ width: 200 }}
                        onClick={() => {
                            window.print()
                        }}
                    >
                        印刷プレビュー
                    </Button>
                </div>
            </Flex>
            {api.response.results &&
                chunks().map((chunk, i) => {
                    return (
                        <A4 padding={5} landscape={false} key={'page' + i}>
                            <Table bordered style={{ fontSize: 9, marginTop: 10, textAlign: 'center', backgroundColor: '' }}>
                                <thead>
                                    <tr style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                        <th style={{ width: 30, padding: 0 }}>
                                            <BiCheckboxChecked size={20}></BiCheckboxChecked>
                                        </th>
                                        <th>No</th>
                                        <th style={{ width: 100 }}>バーコードNo</th>
                                        <th style={{ width: 170 }}>読み取りチェック</th>
                                        <th style={{ width: 120 }}>検体コード</th>
                                        <th style={{ width: 100, padding: 0 }}>Rack</th>
                                        <th style={{ width: 100, padding: 0, maxWidth: 140 }}>TubeLocation</th>
                                        <th style={{ minWidth: 200, padding: 0, maxWidth: 140 }}>メモ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {chunk.map((sample, j) => {
                                        const tubeNumber = sample.requestForm?.code ?? ''
                                        const inputedTubeNumber = form.object[j]?.inputedTubeNumber ?? ''
                                        const isOldRequestForm = /[a-zOI]/.test(inputedTubeNumber)

                                        return (
                                            <tr key={'sample' + sample.id + `${j}`}>
                                                <Td>
                                                    <input
                                                        type="checkbox"
                                                        style={{ width: 10, height: 10 }}
                                                        checked={tubeNumber ? tubeNumber === formatRequestFormCode(inputedTubeNumber) : false}
                                                    />
                                                </Td>
                                                <Td>{j + 1 + section * i}</Td>
                                                <Td>{sample.requestForm?.code}</Td>
                                                <Td>
                                                    {tubeNumber && (
                                                        <>
                                                            <InputField
                                                                form={form}
                                                                attr={[j, 'inputedTubeNumber']}
                                                                style={{ margin: 0, height: 25, fontSize: 12, position: 'relative' }}
                                                                tabIndex={j}
                                                                onChange={(e) => {
                                                                    // setTimeoutで300ms後にfocusを次に移す
                                                                    setTimeout(() => {
                                                                        focusNextElement(j + 1)
                                                                    }, 300)
                                                                }}
                                                            />
                                                            {(() => {
                                                                if (!form.object[j] || !form.object[j].inputedTubeNumber) return

                                                                // 医療機関の旧RequestFormコードの検体をピックアップする場合があるため、新たなルールのバーコードNoに変換し、検体を照合する
                                                                const replacedTubeNumber = formatRequestFormCode(inputedTubeNumber)
                                                                if (tubeNumber !== replacedTubeNumber) {
                                                                    return (
                                                                        <div style={{ fontSize: 9, color: 'red', marginTop: 5 }}>
                                                                            正しいコードを
                                                                            <br />
                                                                            スキャンしてください
                                                                        </div>
                                                                    )
                                                                }
                                                            })()}
                                                        </>
                                                    )}
                                                </Td>
                                                <Td>{sample.code}</Td>
                                                <Td>{sample.rack?.locationCode}</Td>
                                                <Td>{sample.tubeLocation}</Td>
                                                <Td>
                                                    {isOldRequestForm && (
                                                        <div
                                                            style={{
                                                                fontSize: 9,
                                                                marginTop: -15,
                                                                position: 'absolute',
                                                                right: 75,
                                                            }}
                                                        >
                                                            旧バーコードNoを読み取りました
                                                        </div>
                                                    )}
                                                </Td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </A4>
                    )
                })}
        </>
    )
}

export default withRouter(PickingSamples)
